import Icon from 'assets/images/checked.svg'

const CheckedIcopn = ({ ...rest }) => (
  <img src={Icon} alt="check icon" {...rest} />
)

export default CheckedIcopn
